import React, { useContext, useEffect, useRef, useState } from 'react'
import { Grid, Typography, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormContext } from '../Context/Context';
import { useLocation } from 'react-router-dom';
import { useReadOnly } from '../Context/ReadOnlyContext';
import { FinalValuesContext } from '../Context/FinalValuesContext';
import ConvertTitle from './ConvertTitle';

const SingleChoice = ({ id, options, header }) => {


    const { drawerData } = useFormContext();


    const location = useLocation();
    const currentPage = location.pathname;
    const existingComponentIndex = drawerData.findIndex(component => component.id === id);
    let switchHeader = header ? header : drawerData[existingComponentIndex]?.state.titleValue ? drawerData[existingComponentIndex].state.titleValue : 'یک عنوان وارد کنید'
    let isReadOnly = currentPage.startsWith('/publish') || currentPage.startsWith("/card-form/publish") || currentPage.startsWith("/user/fill-form/");



    const { readOnly } = useReadOnly();
    const { finalSelectValues } = useContext(FinalValuesContext);



    let switchOption = options ?
        options
        :
        drawerData[existingComponentIndex]?.state.singleData.length > 0
            ?
            drawerData[existingComponentIndex].state.singleData
            :
            [
                { id: 1, label: 'گزینه اول را وارد کنید', checked: false },
                { id: 2, label: 'گزینه دوم را وارد کنید', checked: false },
                { id: 3, label: 'گزینه سوم را وارد کنید', checked: false },
                { id: 4, label: 'گزینه چهارم را وارد کنید', checked: false },
            ]



    const [singleData, setSingleData] = useState(switchOption)
    const [titleValue, setTitleValue] = useState(switchHeader);
    const [isSubHeaderVisible, setSubHeaderVisible] = useState(false);
    const [isHeadingFocused, setHeadingFocused] = useState(false);
    const [show, setShow] = useState(true);
    const [hoverStates, setHoverStates] = useState({});
    const [draggedItemId, setDraggedItemId] = useState(null);
    const [selectedOption, setSelectedOption] = useState(drawerData[existingComponentIndex]?.state.mainSelectedOption);
    const [condition, setCondition] = useState(false)


    const containerRef = useRef(null);
    const inputOptionRef = useRef(null);




    const fillInputValue = () => {

        if (drawerData.length > 0) {

            if (drawerData[existingComponentIndex]) {
                drawerData[existingComponentIndex].state.titleValue = titleValue;
                drawerData[existingComponentIndex].state.singleData = singleData;
                drawerData[existingComponentIndex].state.mainSelectedOption = selectedOption;
                drawerData[existingComponentIndex].state.readOnly = readOnly
            }

        }
    };


    let titleIndex = finalSelectValues.findIndex(item => item.name === "FieldCondition")
    let title = ConvertTitle({ title: finalSelectValues[titleIndex]?.value });
    let dataIndex = drawerData.findIndex(item => item.title === title)
    let dataCondition = drawerData[dataIndex]?.state.readOnly


    const handleCondition = () => {
        if (currentPage === '/Publish') {
            if (readOnly || dataCondition) {
                if (title === 'SingleChoice') {
                    setCondition(true)
                } else {
                    setCondition(false)
                }
            } else {
                setCondition(false)
            }
        } else {
            setCondition(false)
        }

    }


    const handleRemoveOption = (id) => {

        if (!condition) {
            const updatedData = singleData.filter(item => item.id !== id);
            // Check if "Other" option exists after removing an option
            const isOtherOptionExists = updatedData.some(item => item.label.trim().toLowerCase() === 'other');
            setSingleData(updatedData);
            // Update the show state based on the presence of "Other" option
            setShow(!isOtherOptionExists);
        }

    }

    const handleDragStart = (id) => {
        setDraggedItemId(id);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (targetId) => {
        if (draggedItemId === null || draggedItemId === targetId) {
            return;
        }

        const updatedData = [...singleData];
        const draggedItemIndex = updatedData.findIndex(item => item.id === draggedItemId);
        const targetItemIndex = updatedData.findIndex(item => item.id === targetId);

        // Swap the positions of the dragged item and the target item
        [updatedData[draggedItemIndex], updatedData[targetItemIndex]] = [updatedData[targetItemIndex], updatedData[draggedItemIndex]];

        setSingleData(updatedData);
        setDraggedItemId(null);
    };

    const handleMouseEnter = (id) => {
        setHoverStates(prev => ({ ...prev, [id]: true }));
    };

    const handleMouseLeave = (id) => {
        setHoverStates(prev => ({ ...prev, [id]: false }));
    };

    const handleAddOption = () => {
        const isAnyLabelEmpty = singleData.some(item => item.label.trim() === '');
        const isOtherOptionExists = singleData.some(item => item.label.trim().toLowerCase() === 'سایر');
        const newId = Math.max(...singleData.map(item => item.id)) + 1;
        const newOption = { id: newId, label: '', checked: false };

        if (!isAnyLabelEmpty) {
            setSingleData(prevOptions => {
                const optionsWithoutOther = prevOptions.filter(item => item.label.trim().toLowerCase() !== 'سایر');
                return isOtherOptionExists
                    ? [...optionsWithoutOther, newOption, { id: newId + 1, label: 'سایر', checked: false }]
                    : [...prevOptions, newOption];
            });
        }
    };


    const handleAddOtherOption = () => {
        const newId = Math.max(...singleData.map(item => item.id)) + 1;
        const newOption = { id: newId, label: 'سایر', checked: false };
        setSingleData(prevOptions => [...prevOptions, newOption]);
        setShow(false)
    };


    const handleTitleChange = (event) => {
        setTitleValue(event.target.value);
    };

    const handleChangeOption = (e, id) => {
        const value = e.target.value;

        if (value.trim() === '' && isHeadingFocused === false) {
            // If the input is empty, remove the item from singleData
            setSingleData(prevOptions =>
                prevOptions.filter(item => item.id !== id)
            );
        } else {
            // If the input is not empty, update the label in the corresponding item
            setSingleData(prevOptions =>
                prevOptions.map(item =>
                    item.id === id ? { ...item, label: value } : item
                )
            );
        }
    };


    // Add a global click event listener to handle clicks outside the first grid


    const handleHeadingFocus = (event) => {
        // Select the value of the input when it receives focus (click)
        setHeadingFocused(true); // Set focus state to true
        event.target.select();
    };


    const handleCheckboxChange = (id, label) => {
        setSelectedOption(label);
        setSingleData(prevOptions =>
            prevOptions.map(item =>
                item.id === id ? { ...item, checked: true } : { ...item, checked: false }
            )
        );
    };


    const handleClickOutside = (event) => {
        if (containerRef.current && !containerRef.current.contains(event.target)) {
            setSubHeaderVisible(false);
            setHeadingFocused(false);
        } else {
            setSubHeaderVisible(true);
            setHeadingFocused(true);
        }
    };


    const handeClickOutSideInputOption = (event) => {
        if (inputOptionRef.current && !inputOptionRef.current.contains(event.target)) {
            setSingleData(prevOptions => {
                const updatedOptions = prevOptions.filter(item => item.label.trim() !== '');
                return updatedOptions;
            });
        }
    }


    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        document.addEventListener('click', handeClickOutSideInputOption);

        return () => {
            document.removeEventListener('click', handeClickOutSideInputOption);
        };
    }, []);



    useEffect(() => {
        const fetchData = async () => {
            await fillInputValue();
        };

        fetchData();
    }, [id, titleValue, singleData]);


    useEffect(() => {
        handleCondition()
    }, [finalSelectValues, readOnly])


    let theme = useTheme()
    let HeadingColor = theme.palette.blue[700]


    return (
        <Grid
            mb={currentPage.startsWith('/build') || currentPage.startsWith('/publish') ? '28px' : '50px'}
            p={drawerData.length > 0 ? (currentPage.startsWith('/build') || currentPage.startsWith('/publish') || currentPage.startsWith('/user/fill-form') ? '12px 10px' : { xs: '12px', md: '24px' }) : '0px'}
            mx={currentPage === '/build' || currentPage === '/publish' ? '4px' : '0px'}
            borderRadius={'3px'}
            width={'100%'}
            bgcolor={'white'} ref={containerRef}
            border={`2px solid ${isHeadingFocused && drawerData.length > 0 && drawerData[existingComponentIndex] && !isReadOnly ? '#0293e2' : 'transparent'}`}
            onClick={handleClickOutside}>
            <Grid className={'HeadingInput'} pb={'14px'}>
                <input className="customHead-input" placeholder={'یک عنوان وارد کنید'} style={{
                    border: 'none',
                    outline: 'none',
                    userSelect: 'text',
                    wordWrap: 'break-word',
                    whiteSpace: 'pre-wrap',
                    width: '100%',
                    fontSize: '16px',
                    fontWeight: 700,
                    lineHeight: 1.45,
                    color: HeadingColor,
                    '::placeholder': {
                        color: '#b8bdc9', // Placeholder text color
                    },
                }}
                    readOnly={isReadOnly || condition}
                    value={titleValue}
                    onChange={handleTitleChange}
                    onClick={handleClickOutside}
                    onFocus={isReadOnly ? null : handleHeadingFocus}
                />
            </Grid>
            <Grid ref={inputOptionRef} onClick={handeClickOutSideInputOption}>
                <Grid mb={'10px'}>
                    {
                        singleData.map(
                            item =>
                                <Grid display={'flex'} alignItems={'center'}
                                    position={'relative'}
                                    zIndex={100}
                                    pb={'10px'}
                                    onMouseEnter={() => handleMouseEnter(item.id)}
                                    onMouseLeave={() => handleMouseLeave(item.id)}
                                    draggable
                                    onDragStart={() => handleDragStart(item.id)}
                                    onDragOver={handleDragOver}
                                    onDrop={() => handleDrop(item.id)}
                                >
                                    <Grid display={'flex'} alignItems={'center'} justifyContent={'flex-start'}
                                        width={'fit-content'}
                                    >
                                        <input
                                            disabled={condition}
                                            checked={item.checked}
                                            onChange={(e) => handleCheckboxChange(item.id, item.label)}
                                            name={'radio'} id={'item.id'} type={'radio'} style={{
                                                width: '18px',
                                                height: '18px',
                                            }} />
                                        <label htmlFor={'item.id'}>
                                            {
                                                item.label === 'سایر' ?
                                                    <input
                                                        placeholder={'یک گزینه را وارد کنید'}
                                                        style={{
                                                            border: 'none',
                                                            outline: 'none',
                                                            userSelect: 'text',
                                                            wordWrap: 'break-word',
                                                            whiteSpace: 'pre-wrap',
                                                            width: 'fit-content',
                                                            fontSize: '14px',
                                                            fontWeight: 700,
                                                            lineHeight: 1.45,
                                                            color: HeadingColor,
                                                            paddingTop: '8px',
                                                            cursor: 'not-allowed',
                                                            '::placeholder': {
                                                                color: '#b8bdc9', // Placeholder text color
                                                            },
                                                        }}
                                                        readOnly={isReadOnly || condition}
                                                        value={item.label}
                                                        onClick={handleClickOutside}
                                                    />
                                                    :
                                                    <input
                                                        placeholder={'یک گزینه را وارد کنید'}
                                                        style={{
                                                            border: 'none',
                                                            outline: 'none',
                                                            userSelect: 'text',
                                                            wordWrap: 'break-word',
                                                            whiteSpace: 'pre-wrap',
                                                            width: 'fit-content',
                                                            fontSize: '14px',
                                                            fontWeight: 700,
                                                            lineHeight: 1.45,
                                                            paddingTop: '8px',
                                                            color: HeadingColor,
                                                            '::placeholder': {
                                                                color: '#b8bdc9', // Placeholder text color
                                                            },
                                                        }}
                                                        value={item.label}
                                                        onChange={(e) => handleChangeOption(e, item.id)}
                                                        onClick={handleClickOutside}
                                                        onFocus={handleHeadingFocus}
                                                        readOnly={isReadOnly || condition}
                                                    />
                                            }

                                        </label>
                                    </Grid>
                                    <Grid width={'24px'} height={'24px'} borderRadius={'50%'}
                                        display={hoverStates[item.id] && !isReadOnly ? 'flex' : 'none'} alignItems={'center'}
                                        justifyContent={'center'}
                                        style={{ cursor: 'pointer' }}
                                        sx={[
                                            {
                                                backgroundColor: 'white',
                                                color: '#b8bdc9'
                                            },
                                            {
                                                '&:hover': {
                                                    backgroundColor: '#b8bdc9',
                                                    color: 'white'
                                                },
                                            },
                                        ]}
                                        onClick={currentPage === '/build' || currentPage === "//card-form/build" || condition ? null : () => handleRemoveOption(item.id)}
                                    >
                                        <CloseIcon fontSize={'medium'} />
                                    </Grid>
                                </Grid>
                        )
                    }
                </Grid>
                <Grid display={isReadOnly ? "none" : 'flex'} alignItems={'center'} justifyContent={'flex-start'} gap={'4px'}>
                    <Grid onClick={currentPage === '/build' || currentPage === "//card-form/build" || condition ? null : handleAddOption}
                        sx={[
                            {
                                fontSize: '12px',
                                fontWeight: 500,
                                color: '#636a96',
                                padding: '5px 10px',
                                backgroundColor: 'white',
                                borderRadius: '4px',
                                transition: 'all 0.25s ease',
                                border: 'none',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            {
                                '&:hover': {
                                    backgroundColor: '#636a96',
                                    color: 'white',
                                },
                            },
                        ]}>
                        افزودن گزینه
                    </Grid>
                    <Grid onClick={isReadOnly || condition ? null : handleAddOtherOption} display={show && !isReadOnly ? 'block' : 'none'}
                        sx={[
                            {
                                fontSize: '12px',
                                fontWeight: 500,
                                color: '#636a96',
                                padding: '5px 10px',
                                backgroundColor: 'white',
                                borderRadius: '4px',
                                transition: 'all 0.25s ease',
                                border: 'none',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            },
                            {
                                '&:hover': {
                                    backgroundColor: '#636a96',
                                    color: 'white',
                                },
                            },
                        ]}
                    >
                        گزینه "سایر" را اضافه کنید
                    </Grid>
                </Grid>
            </Grid>
            <Grid mt={'5px'}>
                <Typography variant='subtitle2'>با کلیک بر روی گزینه میتوانید تربیت گزینه ها را جابه‌جا کنید</Typography>
            </Grid>
        </Grid>
    )
}
export default SingleChoice
